import React from 'react';
import { useTranslation } from '../../hx/useTranslation';
import CxSearcher from '../../cx/CxSearcher';
import CxSnackbar from '../../cx/CxSnackbar';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxFetch from '../../fx/FxFetch';
import '../../../styles/main.css';
import GxForm from '../../gx/GxForm';
import CxIconButton from '../../cx/CxIconButton';
//import { useNav } from '../../hx/useNav';


const MxSettPsMergeSubgroupForm = (props) => {
  const [{ trans }] = useTranslation();
  //const [{ navBack }] = useNav();
  const r_snack_required = React.useRef(null);
  const r_snack_same_item = React.useRef(null);
  const r_snack_op_in_progress = React.useRef(null);
  const r_snack_op_successful = React.useRef(null);
  let r_form = React.useRef(null);

  const rf_txTypePsSubgroupToKeep = React.useRef(null);
  const rf_txTypePsSubgroupToDelete = React.useRef(null);


  React.useEffect(() => {
    // eslint-disable-next-line
  }, []);
  
  const doMerge = () => {
    // chequea requeridos
    if (rf_txTypePsSubgroupToKeep.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypePsSubgroupToKeep.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txTypePsSubgroupToDelete.current.isEmpty()) {
      r_snack_required.current.setVal(trans('field.required') + ": " + rf_txTypePsSubgroupToDelete.current.getLabel());
      r_snack_required.current.setOpen(true);
      return;
    }
    if (rf_txTypePsSubgroupToKeep.current.getKey()===rf_txTypePsSubgroupToDelete.current.getKey()) {
      r_snack_same_item.current.setOpen(true);
      return;
    }
    
    let itPsSubgroup_toKeep = rf_txTypePsSubgroupToKeep.current.getKey();
    let itPsSubgroup_toDelete = rf_txTypePsSubgroupToDelete.current.getKey();

    let record = {};
    record['itPsSubgroup_toKeep'] = itPsSubgroup_toKeep;
    record['itPsSubgroup_toDelete'] = itPsSubgroup_toDelete;
    r_snack_op_in_progress.current.setOpen(true);
    Promise.all([FxFetch.doJsonX(`sett/ps/merge/subgroup/do`, record)]).then((result) => {
      rf_txTypePsSubgroupToKeep.current.clear();
      rf_txTypePsSubgroupToDelete.current.clear();
      r_snack_op_in_progress.current.setOpen(false);
      r_snack_op_successful.current.setOpen(true);
    });
  }

  return (
    <div>
      <GxForm
        moduleName={`${trans('field.merge_x', 'field.subgroups')}`}
        xref={r_form}
        addToolbarButtons={
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <CxIconButton type="issue" classType="ibs_iconbutton_toolbar" onClick={doMerge} tooltip={trans('field.merge_duplicates')} />
          </div>
        }
      >

      <CxSearcher xref={rf_txTypePsSubgroupToKeep}
        label={trans('field.keep')}
        url="sett/ps_subgroup" 
        col_id="itPsSubgroup" 
        col_tx="txTypePsSubgroup"
        tooltip={`${trans('field.subgroup')} / ${trans('field.group')}`}
        columns={[
          { id: "0", Header: "ID", accessor: "itPsSubgroup", show: false },
          { id: "1", Header: trans('field.subgroup'), accessor: row => rf_txTypePsSubgroupToKeep.current.getTable().highlightText(row["txTypePsSubgroup"]), width: '50%' },
          { id: "2", Header: trans('field.group'), accessor: row => rf_txTypePsSubgroupToKeep.current.getTable().highlightText(row["txTypePsGroup"]), width: '50%' },
        ]}
        width='var(--ibs_control_width_md)'
        required
      />

      <CxSearcher xref={rf_txTypePsSubgroupToDelete}
        label={trans('field.delete')}
        url="sett/ps_subgroup" 
        col_id="itPsSubgroup" 
        col_tx="txTypePsSubgroup"
        tooltip={`${trans('field.subgroup')} / ${trans('field.group')}`}
        columns={[
          { id: "0", Header: "ID", accessor: "itPsSubgroup", show: false },
          { id: "1", Header: trans('field.subgroup'), accessor: row => rf_txTypePsSubgroupToDelete.current.getTable().highlightText(row["txTypePsSubgroup"]), width: '50%' },
          { id: "2", Header: trans('field.group'), accessor: row => rf_txTypePsSubgroupToDelete.current.getTable().highlightText(row["txTypePsGroup"]), width: '50%' },
        ]}
        width='var(--ibs_control_width_md)'
        required
      />

      </GxForm>

      <CxSnackbar xref={r_snack_required} severity="error" />
      <CxSnackbar xref={r_snack_same_item} severity="error" value={trans('msg.same_item')} />
      <CxSnackbar xref={r_snack_op_in_progress} severity="info" value={trans('msg.operation_in_progress')} autoHideDuration={10000} />
      <CxSnackbar xref={r_snack_op_successful} severity="success" value={trans('msg.operation_successful')} />
    </div>
  );

}

export default MxSettPsMergeSubgroupForm;
